import algoliasearch from 'algoliasearch/lite';

const {searchTerm, indexName, pagesize} = window.aw_search_results;
const {keys: algoliaKeys} = window.aw_search_results;

const client = algoliasearch(algoliaKeys.app_id, algoliaKeys.key);
const index = client.initIndex(indexName);


const wrapper = $('.search-results-wrapper');
const noResultsMessage = $('.no-results-wrapper');
const searchField = $('.js-advanced-search-field');

const filtersWrapper = $('.search-results-filters-container');
const resultsContainer = $('.search-results-container');
const resultTemplate = _.template($('#aw-search-result-tpl').html());

class Search {
    constructor() {
        this.setRequestDefaultOptions();

        searchField.on('keyup faux-search', (e) => this.doSearch());

        searchField.on('faux-search', (e) => {
            this.currentPage = 0;
            this.doSearch();
        }).trigger('faux-search');

        $(document).on('click', '.facet-filter', (e) => this.toggleFacets(e));
        $(document).on('click', '.pagination-item', (e) => this.toggleFacets(e));
        $(document).on('click', '.toggle-facet-widget', (e) => this.toggleFacetWidget(e));
    }


    setRequestDefaultOptions() {
        this.isLoading = false;

        this.currentPage = 0;
        this.hitsPerPage = pagesize;
        this.attributesToRetrieve = [
            'id',
            'title',
            'permalink',
            'media-type',
            'location',
            'date'
        ];

        this.availableFacets = [
            'people',
            'practice',
            'location',
            'source',
            'year',
            'media-type'
        ];

        this.filters = [];
    }

    stopLoading() {
        this.isLoading = false;
        wrapper.removeClass('is-loading');
    }

    startLoading(delay = 500) {
        this.isLoading = true;
        setTimeout(() => this.isLoading && wrapper.addClass('is-loading'), delay);
    }

    showPagination() {

    }

    showResults(results) {
        const resultsMarkup = results.map(item => resultTemplate({item}));
        resultsContainer.html(resultsMarkup);

        if (results.length === 0) {
            noResultsMessage.show();
            wrapper.hide();
        } else {
            noResultsMessage.hide();
            wrapper.show();
        }
    }

    _getFacet(name, filters) {
        const deleteFilter = '<span class="delete-search-facet">&times;</span>';
        const addFilter = '<span class="add-search-facet">&plus;</span>';
        let markup = '<div class="search-facet">';

        markup += `<h3 class="toggle-facet-widget">${ name.toUpperCase().replace(/-/, ' ') }</h3>`;

        markup += '<ul>';

        markup += Object.keys(filters).map(filter => {
            const escapedFilter = filter
                .replace(/'/, "\'")
                .replace(/"/, '\\"');

            const formattedFilter = `${ name }:"${ escapedFilter }"`;
            const isUsed = this.filters.indexOf(formattedFilter) !== -1;

            return `<li class="facet-filter" data-count="${ filters[filter] }" data-facet="${ name }" data-filter="${ escapedFilter }">${ isUsed ? deleteFilter : addFilter }${ filter }</li>`;
        }).join("\n");

        markup += '</ul>';
        markup += '</div>';

        return markup;
    }

    showFacets(facets) {
        const markup = Object.keys(facets).map((facet) => this._getFacet(facet, facets[facet]));

        filtersWrapper.html(markup);
    }

    toggleFacets(e) {
        const el = $(e.currentTarget);
        const filter = `${ el.data('facet') }:"${ el.data('filter') }"`;

        if (this.filters.indexOf(filter) === -1) {
            this.filters.push(filter);
        } else {
            delete this.filters[this.filters.indexOf(filter)];
        }

        searchField.trigger('faux-search');
    }

    toggleFacetWidget(e) {
        const el = $(e.currentTarget);
        el.toggleClass('is-collapsed');
    }


    doSearch() {
        this.startLoading();
        const requestOptions = {
            hitsPerPage: this.hitsPerPage,
            page: this.currentPage,
            attributesToRetrieve: this.attributesToRetrieve,
            facets: this.availableFacets,
            ignorePlurals: true,
            filters: this.filters.filter(f => f).join(" AND "),
            // maxFacetHits: 100,
            // searchableAttributes: [],
            // sortFacetValuesBy: 'alpha',
        };

        return index.search(searchField.val(), requestOptions)
            .then(results => {
                this.stopLoading();

                this.showResults(results.hits);

                this.showPagination(results.nbPages, results.page);
                this.showFacets(results.facets);
            });
    }

}

new Search;